export enum FileAttachmentStatus {
  VISIBLE = 'VISIBLE',
  PARTIALLY_VISIBLE = 'PARTIALLY_VISIBLE',
  HIDDEN = 'HIDDEN',
  DELETED = 'DELETED',
}
